export default "__VITE_ASSET__D$QLiMdS__"